/**
 * Rillion Prime API v1.0
 * A REST API endpoint for System operations.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../../shared/encoder';
import { Observable } from 'rxjs';

// @ts-ignore
// @ts-ignore
import { Created } from '../model/created';
// @ts-ignore
// @ts-ignore
// @ts-ignore
import { LicenceEntity } from '../model/licenceEntity';
// @ts-ignore
import { LicenceModel } from '../model/licenceModel';
// @ts-ignore
// @ts-ignore

// @ts-ignore
import { BASE_PATH } from '../../shared/variables';
import { Configuration } from '../../shared/configuration';

@Injectable({
  providedIn: 'root',
})
export class LicenceService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach((k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)));
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Lists licence(s) based on specified query parameters
   * Licenced products: None
   * @param licenceId
   * @param licence
   * @param isValid
   * @param isActive
   * @param type
   * @param nextReportingTime
   * @param dateCreated
   * @param licencee
   * @param licenceKey
   * @param licenceNo
   * @param environment
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV10LicenceGet(
    licenceId?: number,
    licence?: string,
    isValid?: boolean,
    isActive?: boolean,
    type?: number,
    nextReportingTime?: string,
    dateCreated?: string,
    licencee?: string,
    licenceKey?: string,
    licenceNo?: string,
    environment?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<Array<LicenceModel>>;
  public apiV10LicenceGet(
    licenceId?: number,
    licence?: string,
    isValid?: boolean,
    isActive?: boolean,
    type?: number,
    nextReportingTime?: string,
    dateCreated?: string,
    licencee?: string,
    licenceKey?: string,
    licenceNo?: string,
    environment?: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<LicenceModel>>>;
  public apiV10LicenceGet(
    licenceId?: number,
    licence?: string,
    isValid?: boolean,
    isActive?: boolean,
    type?: number,
    nextReportingTime?: string,
    dateCreated?: string,
    licencee?: string,
    licenceKey?: string,
    licenceNo?: string,
    environment?: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<LicenceModel>>>;
  public apiV10LicenceGet(
    licenceId?: number,
    licence?: string,
    isValid?: boolean,
    isActive?: boolean,
    type?: number,
    nextReportingTime?: string,
    dateCreated?: string,
    licencee?: string,
    licenceKey?: string,
    licenceNo?: string,
    environment?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<any> {
    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (licenceId !== undefined && licenceId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>licenceId, 'LicenceId');
    }
    if (licence !== undefined && licence !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>licence, 'Licence');
    }
    if (isValid !== undefined && isValid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isValid, 'IsValid');
    }
    if (isActive !== undefined && isActive !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isActive, 'IsActive');
    }
    if (type !== undefined && type !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>type, 'Type');
    }
    if (nextReportingTime !== undefined && nextReportingTime !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>nextReportingTime, 'NextReportingTime');
    }
    if (dateCreated !== undefined && dateCreated !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateCreated, 'DateCreated');
    }
    if (licencee !== undefined && licencee !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>licencee, 'Licencee');
    }
    if (licenceKey !== undefined && licenceKey !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>licenceKey, 'LicenceKey');
    }
    if (licenceNo !== undefined && licenceNo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>licenceNo, 'LicenceNo');
    }
    if (environment !== undefined && environment !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>environment, 'Environment');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<Array<LicenceModel>>(`${this.configuration.basePath}/api/v1.0/licence`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Creates licences based on specified entity parameters
   * Licenced products: None
   * @param licenceEntity
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV10LicencePost(
    licenceEntity?: Array<LicenceEntity>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<Created>;
  public apiV10LicencePost(
    licenceEntity?: Array<LicenceEntity>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<HttpResponse<Created>>;
  public apiV10LicencePost(
    licenceEntity?: Array<LicenceEntity>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<HttpEvent<Created>>;
  public apiV10LicencePost(
    licenceEntity?: Array<LicenceEntity>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'text/json', 'application/_*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.post<Created>(`${this.configuration.basePath}/api/v1.0/licence`, licenceEntity, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
